import { $g } from './global';
class MiCookie {
    prefix = $g.prefix;
    get(key, prefix) {
        const name = `${prefix ?? this.prefix}${key}=`;
        const values = document.cookie.split(';');
        const len = values.length;
        for (let i = 0; i < len; i++) {
            let value = values[i];
            while (value.charAt(0) === ' ')
                value = value.substring(1);
            if (value.indexOf(name) !== -1) {
                return value.substring(name.length, value.length);
            }
        }
        return null;
    }
    set(name, value, expire, prefix) {
        let expires = null;
        if (expire) {
            const date = new Date();
            date.setTime(date.getTime() + expire * 24 * 60 * 60 * 1000);
            expires = `expires=${date.toUTCString()}`;
        }
        const params = [`${prefix ?? this.prefix}${name}=${escape(value)}`, expires, 'path=/'];
        document.cookie = params.join(';');
    }
    del(names, prefix) {
        if (Array.isArray(names)) {
            const len = names.length;
            for (let i = 0; i < len; i++) {
                const name = names[i];
                if (name)
                    this.set(name, '', -1, prefix);
            }
        }
        else {
            this.set(names, '', -1, prefix);
        }
    }
    install(app) {
        return app;
    }
}
export const $cookie = new MiCookie();
export default {
    install(app) {
        app.config.globalProperties.$cookie = $cookie;
        app.provide('$cookie', $cookie);
        return app;
    }
};
